import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Button from "components/common/Button";
import PlgIcon from "plg/shell/PlgIcon";
import { analytics } from "services/analytics";
import { useMeeting } from "plg/meeting/MeetingContext";
import "./Shortlist.scss";

interface Props {
  requestAHireRoute: string;
  onClose: () => void;
}

/** Shortlist already full (the cap is 3): point the customer at Request a hire (prototype cap popup). */
function ShortlistFullPopup({ requestAHireRoute, onClose }: Props) {
  const navigate = useNavigate();
  // PLG: one CTA, Request a meeting (prototype renderCapPopup). Not reachable while there is no cap.
  const meeting = useMeeting();
  const onRequestHire = () => {
    onClose();
    analytics.track("Hire Request Started", { context: "shortlist_full" });
    if (meeting) meeting.open("shortlist_full");
    else navigate(requestAHireRoute);
  };
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="sl-full-title"
      slotProps={{ paper: { className: "sl-room-pop" } }}
    >
      <IconButton aria-label="Close" className="sl-pref-pop__x" onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <div className="sl-full-pop__art" aria-hidden="true">
        <PlgIcon name="userPlus" size={28} />
      </div>
      <h2 id="sl-full-title" className="sl-pref-pop__title">
        Looking for someone specific?
      </h2>
      <p className="sl-pref-pop__sub">Tell us who you need and our hiring experts will narrow this down for you.</p>
      <div className="sl-room-pop__actions">
        <Button
          variant="contained"
          size="large"
          label={meeting?.sent ? "Meeting requested" : meeting ? "Request a meeting" : "Request a hire"}
          onClick={onRequestHire}
          disabled={!!meeting?.sent}
        />
        <Button variant="outlined" size="large" label="Not now" onClick={onClose} />
      </div>
    </Dialog>
  );
}

export default ShortlistFullPopup;
